module.exports = __webpack_public_path__ + "img/generated-highway.87dd3f99.png";